import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import { IMPORTANT_DATES_BY_CLIENT_QUERY_KEY } from '../useGetImportantDatesByClientQuery';

export function useDeleteImportantDateMutation() {
  const queryClient = useQueryClient();
  const { doFetch: deleteImportantDate } = useFetch<void, void>();

  return useMutation<void, ErrorResponse<unknown>, { id: number; clientId: number }>({
    mutationFn: ({ id }: { id: number; clientId: number }) =>
      deleteImportantDate(`/api/important-dates/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [IMPORTANT_DATES_BY_CLIENT_QUERY_KEY],
        refetchType: 'all',
      });
    },
  });
}